import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { EventsService } from '../../services/events.service';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { Router } from '@angular/router';
import { CategoriesService } from '../../services/categories.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { EncrDecrService } from '../../services/encr-decr.service';
import { PendingEventsService } from '../services/pending-events.service';

@Component({
  selector: 'app-detailedevent',
  templateUrl: './detailedevent.component.html',
  styleUrls: ['./detailedevent.component.scss']
})
export class DetailedeventComponent implements OnInit {

  @ViewChild('picker') picker: any;

  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: Date;
  public maxDate: Date;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  public disableMinute = false;
  public hideTime = false;

  public dateControl = new FormControl(null);

  public options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  public listColors = ['primary', 'accent', 'warn'];

  public stepHours = [1, 2, 3, 4, 5];
  public stepMinutes = [1, 5, 10, 15, 20, 25];

  public categories = [];


  public coOrganizers: any[] = [{
    email: '',
  }];

  public uploader: FileUploader = new FileUploader({});

  rangeDate: FormGroup;
  eventForm: FormGroup;
  eventDetails: any;
  lastIndex: number;
  cancellationReason: boolean;
  submitted = false;
  cancellationReasonForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private eventService: EventsService,
    private EncDecService: EncrDecrService,
    private router: Router,
    private categoriesService: CategoriesService,
    private _snackBar: MatSnackBar,
    private toastr: ToastrService,
    private pendingEvents: PendingEventsService
    ) { }

    recurring: boolean
    date
    eventLength
    startingTime = ""
    endingTime = ""
    eventFee
    
  ngOnInit() {

    this.eventDetails = JSON.parse(localStorage.getItem("eventDetails"))
      console.log(this.eventDetails)

      if ((this.eventDetails.min_fee == 0) && (this.eventDetails.max_fee == 0)){
        this.eventFee = "free"
      } else if ((this.eventDetails.min_fee != 0 && this.eventDetails.min_fee != null) && (this.eventDetails.max_fee != 0 && this.eventDetails.max_fee != null)){
        this.eventFee = "paid"
      }
      if (this.eventDetails.event_dates[0].start_time !==null){this.startingTime = this.eventDetails.event_dates[0].start_time.slice(0,5)}
      
        if (this.eventDetails.event_dates[0].end_time !==null) {this.endingTime = this.eventDetails.event_dates[0].end_time.slice(0,5)}
      // console.log(endingTime)


      this.eventLength = this.eventDetails.event_dates.length - 1

      if(this.eventDetails.is_recurring == 1) {
        this.recurring = true 
     
         this.rangeDate = this.formBuilder.group({
           start: this.eventDetails.event_dates[0].date,
           end: this.eventDetails.event_dates[this.eventLength].date
         });
        
       } else if(this.eventDetails.is_recurring == 0){ 
       this.recurring = false
       this.date = this.eventDetails.event_dates[0].date
       
       }

    this.eventForm = this.formBuilder.group({
      EventName: this.eventDetails.event_name,
      organizerName: this.eventDetails.user.first_name+" "+this.eventDetails.user.last_name,
      description: this.eventDetails.description,
      isRecurring: this.eventDetails.is_recurring,
      date: this.date,
      range_date: this.rangeDate,
      start_time: this.startingTime,
      end_time: this.endingTime,
      Address: this.eventDetails.location,
      eventFee: this.eventFee,
      website: this.eventDetails.website,
      img: [null]
    });

    

    this.categoriesService.getAllCategories().then((res: any) => {
      for (let i = 0; i < res.categories.length; i++) {
        this.categories.push({
          id: res.categories[i].id,
          name: res.categories[i].name,
          selected: this.isSelected(res.categories[i].id)
        })
      }
      console.log()
    })
      .catch((error) => {

      })

      this.lastIndex = this.eventDetails.event_dates.length - 1
      console.log(this.lastIndex) 
  }

  isSelected(id) {
    let x: any[] = this.eventDetails.category_list
    let ids: any[] = []
    x.forEach((res) => {ids.push(res.category_id)}) 
    console.log(x)   
    if (ids.includes(id)) return true;
    return false
  }

  updateCat(){
    console.log(this.categories)
    let selectedcat:any=[];
    for(let i=0; i<this.categories.length;i++){
      if(this.categories[i].selected == true){
        // console.log(this.categories[i].selected, this.categories[i].id)
        // selectedcat.concat(this.categories[i].id)
        selectedcat.push(this.categories[i].id)
      }
    }
    console.log(selectedcat)
    console.log(this.eventDetails.id)
    let string:string
    string = selectedcat.toString()
    console.log(string)
    this.pendingEvents.updateCategory(this.eventDetails.id, string).then((res:any) => {
      console.log(res)
    })
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  toggleMinDate(evt: any) {
    if (evt.checked) {
      this._setMinDate();
    } else {
      this.minDate = null;
    }
  }

  toggleMaxDate(evt: any) {
    if (evt.checked) {
      this._setMaxDate();
    } else {
      this.maxDate = null;
    }
  }

  closePicker() {
    this.picker.cancel();
  }

  private _setMinDate() {
    const now = new Date();
    this.minDate = new Date();
    this.minDate.setDate(now.getDate() - 1);
  }


  private _setMaxDate() {
    const now = new Date();
    this.maxDate = new Date();
    this.maxDate.setDate(now.getDate() + 1);
  }

  changeSelected($event, category): void {
    category.selected = $event.selected;
  }


  addAddress() {
    this.coOrganizers.push({
      email: '',
    });
  }

  url;
  msg = "";

  selectFile(event) {

    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }

    const file = (event.target as HTMLInputElement).files[0];
    this.eventForm.patchValue({
      img: file
    });

    this.eventForm.get('img').updateValueAndValidity();
  }

  acceptEvent() {
    console.log(this.categories)
    let selectedcat:any=[];
    for(let i=0; i<this.categories.length;i++){
      if(this.categories[i].selected == true){
        selectedcat.push(this.categories[i].id)
      }
    }
    console.log(selectedcat)
    console.log(this.eventDetails.id)
    let string:string
    string = selectedcat.toString()
    console.log(string)
    this.pendingEvents.updateCategory(this.eventDetails.id, string).then((res:any) => {
      console.log(res)
    })
    this.pendingEvents.modifyEventStatus(this.eventDetails.id, "approved").then((res) => {
      console.log(res);

      this.cancellationReason = false;
      this.router.navigate(['/admin/pendingevents'])
    })
  }
  
  rejectEvent() {
    this.pendingEvents.modifyEventStatus(this.eventDetails.id, "rejected").then((res) => {
      console.log(res);
      this.cancellationReason = false;
      this.router.navigate(['/admin/pendingevents'])
    })
  }

  showCancellation() {
    this.cancellationReason = true;
  }

  hideCancellation() {
    this.cancellationReason = false;
    this.submitted = false;
    this.cancellationReasonForm.reset();
  }


}